class ConfirmationComponentController {
    constructor(_) {
        this._ = _;
    }
   
}

ConfirmationComponentController.$inject = ['_'];


export default  {
    controller: ConfirmationComponentController,
    bindings: {
        acknowledgementItems: '<',
        back: '&',        
        submit: '&'
    },
    templateUrl: `app/components/confirmation/confirmation.html`,
   
};



// WEBPACK FOOTER //
// ./app/components/confirmation/confirmation.component.js